// @ts-check
/**
 * @file favicon.js
 * @location src/utils/favicon.js
 * @role Canvas 로 favicon 위 빨간 배지 그리기 (count 표시).
 *
 *  count === 0 → 원래 favicon.svg 로 복귀.
 *  count > 0   → 32x32 canvas: 짙은 원 + 우상단 빨간 점 + 숫자(1~9 만).
 *
 *  Canvas 미지원 환경(테스트·구형 브라우저)에서는 silently no-op.
 *  jsdom 의 HTMLCanvasElement 는 기본 빈 구현 — context null → no-op.
 */

const ORIGINAL_HREF = '/favicon.svg';
const SIZE = 32;

/**
 * favicon 갱신. data URL 반환(테스트 검증용), 실패 시 빈 문자열.
 * @param {number} count
 * @returns {string}
 */
export function updateFaviconBadge(count) {
  const link = /** @type {HTMLLinkElement | null} */ (document.querySelector('link[rel="icon"]'));
  if (!link) return '';

  const safe = Math.max(0, Math.floor(count ?? 0));

  if (safe === 0) {
    link.setAttribute('href', ORIGINAL_HREF);
    return ORIGINAL_HREF;
  }

  let canvas, ctx;
  try {
    canvas = document.createElement('canvas');
    canvas.width = SIZE;
    canvas.height = SIZE;
    ctx = canvas.getContext('2d');
  } catch {
    return '';
  }
  if (!ctx) return '';

  // 베이스 — 짙은 원형
  ctx.fillStyle = '#1a1a18';
  ctx.beginPath();
  ctx.arc(SIZE / 2, SIZE / 2, SIZE / 2 - 1, 0, Math.PI * 2);
  ctx.fill();

  // 배지 — 우상단 빨간 원
  const badgeR = 9;
  const badgeX = SIZE - badgeR - 1;
  const badgeY = badgeR + 1;
  ctx.fillStyle = '#DC2626';
  ctx.beginPath();
  ctx.arc(badgeX, badgeY, badgeR, 0, Math.PI * 2);
  ctx.fill();

  // 숫자(1~9 만; 10+ 는 점만)
  if (safe <= 9) {
    ctx.fillStyle = '#fff';
    ctx.font = 'bold 12px sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(String(safe), badgeX, badgeY + 1);
  }

  let dataUrl = '';
  try {
    dataUrl = canvas.toDataURL('image/png');
  } catch {
    return '';
  }
  link.setAttribute('href', dataUrl);
  return dataUrl;
}
